/**
 * Endpoints de remitos (input del ERP).
 */

import { GetRemitosResponse, type Remito } from '@/api/contracts/remitos';
import { getDb } from '@/api/mock/db';

const MOCK_LATENCY_MS = 120;
function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** GET /api/remitos — devuelve todos. El front filtra por ubicación activa. */
export async function getRemitos(): Promise<Remito[]> {
  await delay(MOCK_LATENCY_MS);
  return GetRemitosResponse.parse(getDb().remitos);
}
